/* eslint-disable max-len */
import RestService from '../services/rest';

async function getNewRegistersTable(limit, skip, search, order = '', field = '') {
  return RestService.getAuthenticated(`panel/newRegisters/getNewRegistersTable?limit=${limit}&skip=${skip}&search=${search}&order=${order}&field=${field}`);
}

async function resendIntegration(register) {
  return RestService.postAuthenticated('panel/newRegisters/resendIntegration', register);
}

async function getCsvNewRegistersReport() {
  const response = await RestService.getAuthenticated('panel/newRegisters/report/csv', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'new-registers-export.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function updateNewRegister(newRegister) {
  return RestService.putAuthenticated('panel/newRegisters/update', newRegister);
}

export default {
  getNewRegistersTable,
  getCsvNewRegistersReport,
  resendIntegration,
  updateNewRegister,
};
